import { Component, OnInit, ViewChild, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSnackBar, MatDialogConfig } from '@angular/material';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogboxComponent } from '../../../public/dialogbox/dialogbox.component';
import { BatchService } from 'src/app/shared/services/batch.service';
import { AppSettings } from '../../../app.constant';

import { Batch } from '../../../shared/interface/batch';
import { Observable } from 'rxjs';
import { DataSource } from '@angular/cdk/table';

@Component({
  selector: 'app-batch-table',
  templateUrl: './batch-table.component.html',
  styleUrls: ['./batch-table.component.css']
})

export class BatchTableComponent implements OnInit {
  progressBar: boolean = true;
  fileNameDialogRef: MatDialogRef<DialogboxComponent>;
  displayedColumns: string[] = ['BatchCode', 'BatchName', 'Edit'];
  httpResponseMessage: any;
  public resultdata: any;
  post: any;
  Batch: any;
  errorMessage: any;
  status: any;
  dataSource: any;
  durationInSeconds = 2;

  @Output() messageEvent = new EventEmitter<string>();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private _batchService: BatchService,
    changeDetectorRefs: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    public dialog: MatDialog, ) { }

  ngOnInit() {
    this._batchService.refreshNeeded$
      .subscribe(() => {
        this.getAllBatch();
      })
    this.getAllBatch();
  }

  getAllBatch() {
    this._batchService.getAllBatch(AppSettings.API_ENDPOINT + AppSettings.GetAllBatch)
      .subscribe(result => {
        this.resultdata = result;
        this.progressBar = false;
        if (!result) {
          return;
        }
        this.dataSource = new MatTableDataSource(this.resultdata);
        this.dataSource.paginator = this.paginator;
      });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  onEditBatch(param: any): void {
    var o = { PK_BatchID: param.PK_BatchID }
    this.post = JSON.stringify(o);
    this._batchService.getBatchByID(AppSettings.API_ENDPOINT + AppSettings.GetBatchByID, this.post).subscribe(
      data => {
        this.Batch = data;
        // alert(this.post);
        this.messageEvent.emit(this.Batch);
      },
      error => this.errorMessage = <any>error)
  }

  onDeleteBatch(param: any): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title: "Batch",
      data: param.BatchName
    };

    this.fileNameDialogRef = this.dialog.open(DialogboxComponent, dialogConfig);
    this.fileNameDialogRef.afterClosed().subscribe(result => {
      this.status = result;
      if (this.status == "ok") {
        var o = { PK_BatchID: param.PK_BatchID }
        this.post = JSON.stringify(o);
        this._batchService.deleteBatchByID(AppSettings.API_ENDPOINT + AppSettings.DeleteBatch, this.post).subscribe(
          data => {
            this.httpResponseMessage = data;
            this.openSnackBar(this.httpResponseMessage, '');
          },
          error => this.errorMessage = <any>error)
      }
    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: 'bottom'
    });
  }
}
